export const replacePlaceholders = (template, values) => {
    if (!template) {
        return '';
    }
    return template.replace(/#\{([\w\d_-]+)\}/g, (_match, key) => values?.[key] || '');
};
export const generateUuid = () => {
    const parts = [];
    for (let i = 0; i < 16; i += 1) {
        let value = (Math.random() * 256) | 0;
        if (i === 6) {
            value = (value & 0x0f) | 0x40;
        }
        else if (i === 8) {
            value = (value & 0x3f) | 0x80;
        }
        parts.push((0x100 + value).toString(16).substring(1));
        if ([3, 5, 7, 9].includes(i)) {
            parts.push('-');
        }
    }
    return parts.join('');
};
export const generateDict = (fromChar, toChar) => {
    const dict = [];
    for (let current = fromChar; current <= toChar; current++) {
        dict.push(String.fromCharCode(current));
    }
    return dict;
};
